// extracted by mini-css-extract-plugin
export default {"root":"MainNavToggleButton_root__AxPUQ","notification":"MainNavToggleButton_notification__pw-1j"};